import {base} from '../../../models/base';
import { fromJS } from "immutable";

export default {
  namespace: 'travel',
  state: {},
  reducers: Object.assign(
    base,
    {
      setData(state, {items, meta}){
        console.info("travel/items", items);
        return { ...state, items: fromJS(items), orig: fromJS(items), tMeta: meta };
      },
      setExRate(state, {exRate}){
        console.info("travel/exRate", exRate);
        return { ...state, exRate: exRate};
      },
      search(state, {items, keyword}){
        console.info("travel/items:" , items);
        return { ...state, items: fromJS(items), orig: fromJS(items), searchKeyword: keyword };
      },
      /*
      toggleList(state){
        const toggle = !state.toggleList;
        return { ...state, toggleList: toggle };
      },
      */
      //-------------------------------------------------------------
      // Filter
      //-------------------------------------------------------------
      /**
       * Filtering price range
       * @param range
       * @returns {{filterPrice: *}}
       */
      filterPrice(state, {range}){
        const _items = state.orig.filter(x => x.get('price') < range[1]);
        console.info("filter price: ", _items.size);
        return { ...state, filterPrice: range, items: _items };
      },
      /**
       * Filtering city
       * @param city
       * @returns {{filterPrice: *}}
       */
      filterCity(state, {value}){
        console.info("filter city: ", value);
        let _items = [];
        if(value == 'all'){
          _items = state.orig;
        }else{
          _items = state.orig.filter(x => x.get('city_key') == value);
        }
        return { ...state, filterCity: value, items: _items };
      },
      //-------------------------------------------------------------
      // Sort
      //-------------------------------------------------------------
      /**
       * Sort Price
       * @param
       * @returns {{filterPrice: *}}
       */
      sortPrice(state){
      //  const _items = state.orig.filter(x => x.get('price') < range[1]);
        let order = state.sortPrice;
        console.info(state);
/*
        const _items = state.orig.sort((a,b) => {
          if(order == 'asc'){
            return a.get('price') > b.get('price');
          }else{
            return a.get('price') <= b.get('price');
          }
        });
*/
        const _items = state.orig.sort((a,b) => {
          if(order == 'asc') {
            return a.get('price') - b.get('price');
          }else {
            return b.get('price') - a.get('price');
          }
        });

        order = (order == 'asc')?'desc':'asc';
        console.info("sort price: ", order);
        return { ...state, sortPrice: order, items: _items };
      },


      /*
      filterStatus(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('status') === value);
        return { ...state, csItems: csItems, filterStatus: value };
      },
      filterVisa(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('acquired_visa') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      },
      filterSchoolType(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('school_type') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      }
      */
    }
  )
};



// WEBPACK FOOTER //
// ./src/pages/travel/models/travel.js